var map = {
	"./": 312,
	"./Content": 1117,
	"./Content.dictionary": 1119,
	"./Content.dictionary.json": 1119,
	"./Content.jsx": 1117,
	"./ContentDeferred": 351,
	"./ContentDeferred.jsx": 351,
	"./InterestingMatches": 1004,
	"./InterestingMatches/": 1004,
	"./InterestingMatches/InterestingMatches.dictionary": 1020,
	"./InterestingMatches/InterestingMatches.dictionary.json": 1020,
	"./InterestingMatches/InterestingMatches.module.scss": 837,
	"./InterestingMatches/actions": 98,
	"./InterestingMatches/actions.ts": 98,
	"./InterestingMatches/components/Contetnt": 923,
	"./InterestingMatches/components/Contetnt/": 923,
	"./InterestingMatches/components/Contetnt/Content.dictionary": 959,
	"./InterestingMatches/components/Contetnt/Content.dictionary.json": 959,
	"./InterestingMatches/components/Contetnt/Content.module.scss": 1019,
	"./InterestingMatches/components/Contetnt/index": 923,
	"./InterestingMatches/components/Contetnt/index.tsx": 923,
	"./InterestingMatches/components/Match": 843,
	"./InterestingMatches/components/Match/": 843,
	"./InterestingMatches/components/Match/Match.dictionary": 848,
	"./InterestingMatches/components/Match/Match.dictionary.json": 848,
	"./InterestingMatches/components/Match/index": 843,
	"./InterestingMatches/components/Match/index.tsx": 843,
	"./InterestingMatches/components/Sport": 958,
	"./InterestingMatches/components/Sport.tsx": 958,
	"./InterestingMatches/components/Stage": 874,
	"./InterestingMatches/components/Stage.tsx": 874,
	"./InterestingMatches/components/Tournament": 892,
	"./InterestingMatches/components/Tournament.jsx": 892,
	"./InterestingMatches/components/Union": 924,
	"./InterestingMatches/components/Union.jsx": 924,
	"./InterestingMatches/constants": 925,
	"./InterestingMatches/constants.ts": 925,
	"./InterestingMatches/index": 1004,
	"./InterestingMatches/index.jsx": 1004,
	"./InterestingMatches/reducer": 295,
	"./InterestingMatches/reducer/": 295,
	"./InterestingMatches/reducer/entities": 368,
	"./InterestingMatches/reducer/entities.js": 368,
	"./InterestingMatches/reducer/grid": 369,
	"./InterestingMatches/reducer/grid.js": 369,
	"./InterestingMatches/reducer/index": 295,
	"./InterestingMatches/reducer/index.js": 295,
	"./InterestingMatches/selectors": 829,
	"./InterestingMatches/selectors/": 829,
	"./InterestingMatches/selectors/entities": 274,
	"./InterestingMatches/selectors/entities.ts": 274,
	"./InterestingMatches/selectors/grid": 847,
	"./InterestingMatches/selectors/grid.ts": 847,
	"./InterestingMatches/selectors/index": 829,
	"./InterestingMatches/selectors/index.ts": 829,
	"./LandingPage.module.scss": 1158,
	"./MatchOfTheDay": 1005,
	"./MatchOfTheDay/": 1005,
	"./MatchOfTheDay/actions": 305,
	"./MatchOfTheDay/actions.ts": 305,
	"./MatchOfTheDay/components/Carousel": 960,
	"./MatchOfTheDay/components/Carousel/": 960,
	"./MatchOfTheDay/components/Carousel/Carousel.module.scss": 1118,
	"./MatchOfTheDay/components/Carousel/index": 960,
	"./MatchOfTheDay/components/Carousel/index.tsx": 960,
	"./MatchOfTheDay/components/MainStakes": 926,
	"./MatchOfTheDay/components/MainStakes/": 926,
	"./MatchOfTheDay/components/MainStakes/MainStakes.module.scss": 1021,
	"./MatchOfTheDay/components/MainStakes/index": 926,
	"./MatchOfTheDay/components/MainStakes/index.tsx": 926,
	"./MatchOfTheDay/components/MatchTile": 961,
	"./MatchOfTheDay/components/MatchTile/": 961,
	"./MatchOfTheDay/components/MatchTile/MatchDetails": 1022,
	"./MatchOfTheDay/components/MatchTile/MatchDetails.tsx": 1022,
	"./MatchOfTheDay/components/MatchTile/MatchTile.module.scss": 962,
	"./MatchOfTheDay/components/MatchTile/MatchTitle.dictionary": 1023,
	"./MatchOfTheDay/components/MatchTile/MatchTitle.dictionary.json": 1023,
	"./MatchOfTheDay/components/MatchTile/index": 961,
	"./MatchOfTheDay/components/MatchTile/index.tsx": 961,
	"./MatchOfTheDay/images/background.svg": 1171,
	"./MatchOfTheDay/images/pattern.svg": 1172,
	"./MatchOfTheDay/index": 1005,
	"./MatchOfTheDay/index.tsx": 1005,
	"./MatchOfTheDay/reducer": 370,
	"./MatchOfTheDay/reducer.ts": 370,
	"./MatchOfTheDay/selectors": 883,
	"./MatchOfTheDay/selectors/": 883,
	"./MatchOfTheDay/selectors/entities": 279,
	"./MatchOfTheDay/selectors/entities.ts": 279,
	"./MatchOfTheDay/selectors/grid": 914,
	"./MatchOfTheDay/selectors/grid.ts": 914,
	"./MatchOfTheDay/selectors/index": 883,
	"./MatchOfTheDay/selectors/index.ts": 883,
	"./MatchOfTheDay/utils/get-match-ids-from-banners": 1060,
	"./MatchOfTheDay/utils/get-match-ids-from-banners.ts": 1060,
	"./MiniBanners": 1006,
	"./MiniBanners/": 1006,
	"./MiniBanners/MiniBanners": 963,
	"./MiniBanners/MiniBanners.module.scss": 1024,
	"./MiniBanners/MiniBanners.tsx": 963,
	"./MiniBanners/components/Content": 893,
	"./MiniBanners/components/Content/": 893,
	"./MiniBanners/components/Content/Content": 875,
	"./MiniBanners/components/Content/Content.module.scss": 927,
	"./MiniBanners/components/Content/Content.tsx": 875,
	"./MiniBanners/components/Content/index": 893,
	"./MiniBanners/components/Content/index.ts": 893,
	"./MiniBanners/index": 1006,
	"./MiniBanners/index.ts": 1006,
	"./images/telegram.svg": 1173,
	"./index": 312,
	"./index.tsx": 312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1240;
module.exports = webpackContext;